/**
 * @generated SignedSource<<31ac845d9656269d826422e3ddb9c92f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateAICustomAppInput = {
  description?: string | null;
  name: string;
  scope: string;
  workflowExternalId: string;
  workflowGuid: any;
  workflowInterfaceId: string;
};
export type aiCustomAppsCreateMutation$variables = {
  input: CreateAICustomAppInput;
};
export type aiCustomAppsCreateMutation$data = {
  readonly createAICustomApp: {
    readonly aiCustomAppID: number;
    readonly description: string | null;
    readonly isActive: boolean;
    readonly mediaFactoryAppID: number;
    readonly name: string;
  };
};
export type aiCustomAppsCreateMutation = {
  response: aiCustomAppsCreateMutation$data;
  variables: aiCustomAppsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AICustomApp",
    "kind": "LinkedField",
    "name": "createAICustomApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiCustomAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mediaFactoryAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCustomAppsCreateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiCustomAppsCreateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "3bf1b7bec0058ad74be805ffa1f7870b",
    "id": null,
    "metadata": {},
    "name": "aiCustomAppsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation aiCustomAppsCreateMutation(\n  $input: CreateAICustomAppInput!\n) {\n  createAICustomApp(input: $input) {\n    aiCustomAppID\n    name\n    description\n    mediaFactoryAppID\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6f2d4436cd5c63991d18bdcea5c7939";

export default node;
